import { render } from "./IconRoundaboutRightAlt.vue?vue&type=template&id=2b91437a"
import script from "./IconRoundaboutRightAlt.vue?vue&type=script&lang=js"
export * from "./IconRoundaboutRightAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__